import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { useDispatch } from 'app/modules/react-redux';
import * as Actions from 'app/store/actions';

const QuickPanelToggleButton = ({ children = <Icon>format_list_bulleted</Icon> }) => {
	const dispatch = useDispatch();

	return (
		<IconButton className="w-64 h-64" onClick={(_ev) => dispatch(Actions.toggleQuickPanel())} size="large">
			{children}
		</IconButton>
	);
};

export default QuickPanelToggleButton;
